import React from 'react'
import Header from '../../components/Header';

function Events() {
  return (
    <Header />
  )
}

export default Events